import { render } from "./BaseRadio.vue?vue&type=template&id=78f0c842"
import script from "./BaseRadio.vue?vue&type=script&lang=ts"
export * from "./BaseRadio.vue?vue&type=script&lang=ts"

import "./BaseRadio.vue?vue&type=style&index=0&id=78f0c842&lang=scss"
script.render = render

export default script